<script setup lang="ts">
import { RouterView } from "vue-router";
import AppHeader from "@/components/AppHeader.vue";
import GwtInitializer from "./views/GwtInitializer.vue";
import AppFooter from "@/components/AppFooter.vue";
import Toast from "primevue/toast";
import ChatWindow from "@/components/messaging/ChatWindow.vue";
import { useChatWindowStore } from "@/stores/chatWindow.store";

const chatWindowStore = useChatWindowStore();
</script>

<template>
  <div class="flex flex-col min-h-dvh">
    <AppHeader />
    <main id="appMain" class="grow overflow-auto relative">
      <RouterView />
      <GwtInitializer />
      <Toast />
      <div class="absolute bottom-0 right-6 items-end flex flex-row gap-2">
        <ChatWindow
          v-for="(thread, index) in chatWindowStore.openThreads"
          :key="thread.threadId"
          :thread-id="thread.threadId"
          :minimized="thread.minimized"
          @close="chatWindowStore.closeThread(thread.threadId)"
          @minimize="chatWindowStore.minimizeThread(thread.threadId)"
          @maximize="chatWindowStore.maximizeThread(thread.threadId)"
          @interact="chatWindowStore.bringToFront(thread.threadId)"
        />
      </div>
    </main>
    <AppFooter />
  </div>
</template>